  <template>
    <section class="hero-section text-center py-2 hero-text">
      <div class="container mb-5">
        <h1 class="hero-title">Welcome to Poorent</h1>
        <p class="hero-subtitle">
          Experience Rome in Style: Travel Through History with Iconic Rides.At Poorent, we specialize in providing tourists with convenient and stylish car rental
            services to explore Rome. From historical Fiats to modern Golf Cars and Segways, we ensure
            you travel through the Eternal City in comfort and style.
        </p>
        <a href="#services" class=" hero-button">Explore Services</a>
      </div>
    </section>
  </template>
  
  <script>
  export default {
    name: "HeroSection",
  };
  </script>
  